import { Component } from '@angular/core';
import { ModalController, NavController, NavParams } from 'ionic-angular';
import { WpProvider } from '../../providers/wp/wp';
import { PhcApp, PhcAppGallery } from '../../classes/phc-app/phc-app';
import { GalleryAlbumModal } from './gallery-album-modal';

/**
 * Generated class for the GalleryPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-gallery',
  templateUrl: 'gallery.html',
})
export class GalleryPage {

  phcApp: PhcApp;
  gallery: PhcAppGallery;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    wp: WpProvider,
    private modalCtrl: ModalController,
  ) {
    this.phcApp = wp.app;
    this.gallery = this.phcApp.getGallery(navParams.get('galleryId'));
    console.log(this.gallery);
  }

  launchGallery(album) {
    let albumModal = this.modalCtrl.create(GalleryAlbumModal, {galleryId: this.gallery.id, albumIndex: this.gallery.albums.indexOf(album)});
    albumModal.present();
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad GalleryPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/gallery/gallery.ts